export default {
  'error:title': 'Сервис уақытша <br />істемей тұр',
  'error:text': 'Біз ақауды жөндеп жатырмыз. 15&nbsp;минуттан кейін қайта байқап&nbsp;көріңіз',
  'error:btn-text': 'OK'
}
